import { useEffect, useRef } from "react";
import { preventDefault } from "../utils/dom.mjs";
import { useContainer } from "./useContainer.mjs";
import { useMaybeEditor } from "./useEditor.mjs";
import { useEvent } from "./useEvent.mjs";
function isScrollableOverflow(overflow) {
  return overflow === "auto" || overflow === "scroll" || overflow === "overlay";
}
function isScrollable(elm) {
  const overflowsY = elm.scrollHeight > elm.clientHeight;
  const overflowsX = elm.scrollWidth > elm.clientWidth;
  if (!overflowsY && !overflowsX) return false;
  const style = getComputedStyle(elm);
  return overflowsY && isScrollableOverflow(style.overflowY) || overflowsX && isScrollableOverflow(style.overflowX);
}
function hasScrollableElement(target, root) {
  if (!(target instanceof Node)) {
    return isScrollable(root);
  }
  let elm = target instanceof Element ? target : target.parentElement;
  while (elm) {
    if (elm instanceof HTMLElement && isScrollable(elm)) {
      return true;
    }
    if (elm === root) return false;
    elm = elm.parentElement;
  }
  return false;
}
function usePassThroughWheelEvents(ref) {
  if (!ref) throw Error("usePassThroughWheelEvents must be passed a ref");
  const container = useContainer();
  const editor = useMaybeEditor();
  const onWheel = useEvent((e) => {
    if (!editor?.getInstanceState().isFocused) return;
    if (e.isSpecialRedispatchedEvent) return;
    const elm = ref.current;
    if (elm && hasScrollableElement(e.target, elm)) {
      return;
    }
    preventDefault(e);
    const cvs = container.querySelector(".tl-canvas");
    if (!cvs) return;
    const newEvent = new WheelEvent("wheel", e);
    newEvent.isSpecialRedispatchedEvent = true;
    cvs.dispatchEvent(newEvent);
  });
  const attached = useRef(null);
  useEffect(() => {
    const elm = ref.current;
    if (elm === attached.current) return;
    attached.current?.removeEventListener("wheel", onWheel);
    attached.current = elm;
    elm?.addEventListener("wheel", onWheel, { passive: false });
  });
  useEffect(() => {
    return () => {
      attached.current?.removeEventListener("wheel", onWheel);
      attached.current = null;
    };
  }, [onWheel]);
}
export {
  usePassThroughWheelEvents
};
//# sourceMappingURL=usePassThroughWheelEvents.mjs.map
